import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { useRef, useState } from 'react';
import { ButtonV2, H1, InputTextV2, Modal, P, Span } from 'shared';
import { usePostServicingV1InstrumentsInstrumentIdAgreementsTermsAchAuthorizationMutation } from 'servicing-api';
const GENERIC_ERROR = 'We could not verify your information. Please try again or contact support.';
function AchAuthSsnModal({ isOpen, setIsOpen, instrumentId, bankAccountId, }) {
    const [ssnLast4, setSsnLast4] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isVisible, setIsVisible] = useState(false);
    const inputRef = useRef(null);
    const [fetchAchAuth, { isLoading }] = usePostServicingV1InstrumentsInstrumentIdAgreementsTermsAchAuthorizationMutation();
    const reset = () => {
        setSsnLast4('');
        setErrorMessage('');
        setIsVisible(false);
    };
    const handleClose = () => {
        reset();
        setIsOpen(false);
    };
    const handleChange = (e) => {
        const next = e.target.value;
        if (/^[0-9]*$/.test(next) && next.length <= 4) {
            setSsnLast4(next);
            if (errorMessage)
                setErrorMessage('');
        }
    };
    const handleSubmit = async () => {
        if (!instrumentId || ssnLast4.length !== 4)
            return;
        try {
            const result = await fetchAchAuth({
                instrumentId,
                postServicingV1InstrumentsInstrumentIdAgreementsTermsAchAuthorization: {
                    ssnLastFour: ssnLast4,
                    ...(bankAccountId ? { bankAccountId } : {}),
                },
            }).unwrap();
            if (result.attachment?.url) {
                window.open(result.attachment.url, '_blank');
                setIsOpen(false);
                reset();
            }
            else {
                setErrorMessage(GENERIC_ERROR);
            }
        }
        catch {
            setErrorMessage(GENERIC_ERROR);
        }
    };
    return (_jsx(Modal, { isOpen: isOpen, setIsOpen: setIsOpen, onAfterOpen: () => inputRef.current?.focus(), onRequestClose: handleClose, contentClassName: "flex-modal", withHandle: true, contentLabel: "Verify SSN to view ACH authorization", modalTestId: "ach-auth-ssn-modal", children: _jsxs("div", { className: "flex dir-col align-center pad-32", children: [_jsx(H1, { variant: "headline-large", className: "mar-b-16 text-center", children: "Verify Your Identity" }), _jsx(P, { variant: "body-large", className: "mar-b-24 text-center", children: "Enter the last 4 digits of your SSN/ITIN to view the Payment Authorization Consent Document." }), _jsxs("div", { className: "ach-auth-ssn-input w100 mar-b-16", children: [_jsx(InputTextV2, { ref: inputRef, id: "ach-auth-ssn-last-four", name: "ach-auth-ssn-last-four", "data-testid": "ach-auth-ssn-last-four", type: isVisible ? 'tel' : 'password', inputMode: "numeric", autoComplete: "off", maxLength: 4, value: ssnLast4, onChange: handleChange, placeholder: "Enter last four of SSN/ITIN #", labelElement: _jsx(Span, { variant: "body-medium", bold: true, children: "Last 4 of SSN/ITIN #" }) }), _jsx("button", { type: "button", className: "ach-auth-ssn-input__toggle", onClick: () => setIsVisible((v) => !v), "aria-label": isVisible ? 'Hide SSN' : 'Show SSN', children: isVisible ? _jsx(VisibilityOffIcon, {}) : _jsx(VisibilityIcon, {}) })] }), errorMessage && (_jsx(Span, { variant: "body-medium", className: "red-base mar-b-16 text-center", "data-testid": "ach-auth-ssn-error", children: errorMessage })), _jsx(ButtonV2, { variant: "filled", color: "orange-flex", size: "medium", fullWidth: true, onClick: handleSubmit, disabled: ssnLast4.length !== 4 || isLoading, submitting: isLoading, children: "View Document" })] }) }));
}
export default AchAuthSsnModal;
